import request from '@/utils/request'

const getInvite = (page, limit) => {
  return request({
    url: '/api/invite',
    method: 'post',
    data: {
      page: page,
      limit: limit
    }
  })
}

const collectInviteTurnover = () => {
  return request.get('/api/invite/collect', {
    timeout: 300000 // 5 mins
  })
}

const receivedInviteBonus = () => {
  return request({
    url: '/api/invite/bonus',
    method: 'get'
  })
}
const getInviteBanner = () => {
  return request({
    url: '/api/invite/banners',
    method: 'get'
  })
}
export default {
  getInvite,
  collectInviteTurnover,
  receivedInviteBonus,
  getInviteBanner
}
